/* eslint-disable */
import { resolve } from 'core-js/fn/promise'
// Request actions
// -----
// 1. Use Fetch
// 2. Allways return a promis
// 3. Keep the request as simpel as possible
// 4. Allways catsh a error
// 5. Specify reques type in the name (GET, PUT, POST, DELETE)
// 6. Add documentation, requerd params and expected answer
// 7. ? Dont commit a mutation in a request action ?
// ----

import { i18n } from '../../main'
import { tokenHasExpired } from '../../session-manager'
import { stripHtml } from '../../utilities/helper'

//Test
//const url = 'https://r360-api.klappen.se:8080'
//const url = 'https://klappen-api-test.azurewebsites.net'

//Stage
// const url = 'https://api-stage.klappen.se'

//PROD
// const url = 'https://api.klappen.se'

const url =
	process.env.NODE_ENV === 'production'
		? 'https://api.klappen.se'
		: 'https://api-stage.klappen.se' //https://klappen-api-test.azurewebsites.net/

// isLocal == true - will use local data
let isLocal = process.env.VUE_APP_IS_LOCAL == 'yes'
if (isLocal) {
	window.console.warn(
		'Data is loaded from local JSON. Set VUE_APP_IS_LOCAL to "no" in the .env.local file to prevent this'
	)
}

export default {
	// ******************************************
	//	AUTHENTICATION
	// ******************************************

	GET_AUTHENTICATE_USER({ commit, dispatch }, payload) {
		/*
		PARAMS
			* email
			* password
		RESPONSE
			{
				user,
				tokens
			}
		*/
		// Todo - Change to GET request ?
		return new Promise(resolve => {
			fetch(url + `/api/user/authenticate`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					'X-Login-User': JSON.stringify({
						email: encodeURI(payload.user),
						password: encodeURI(payload.password)
					})
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						commit('SET_TOKEN', data.tokenObject)
						commit('SET_USER', data)
						resolve(true)
					}
				})
				.catch(error => {
					window.console.warn('Fail to loggin')
					window.console.warn(error)
					resolve(false)
				})
		})
	},

	DELETE_TOKEN({ commit, state, dispatch }, payload) {
		/*
		PARAMS
			* Authorization
		RESPONSE
			none ?
		*/
		return new Promise(resolve => {
			let refreshToken = encodeURIComponent(payload.token)
			fetch(url + `/api/user/logout`, {
				method: 'POST',
				body: JSON.stringify(payload),
				headers: new Headers({
					'Content-Type': 'application/json',
					refreshToken: refreshToken,
					Authorization: 'Bearer ' + state.token.accessToken
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						// WE do not get a JSON
						// return resp.json();
						return true
					} else if (resp.status == 401) {
						// Don't promt user to login herer
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					// allways logot user in FrontEnd
					commit('SET_USER', null)
					commit('SET_TOKEN', {
						accessToken: '',
						accessTokenExpiration: '',
						refreshToken: ''
					})

					// If change book in cart
					if (state.cart.resvid) {
						dispatch('EMPTY_CART')
					}

					resolve(true)
				})
				.catch(error => {
					window.console.warn(error)
					resolve(false)
				})
		})
	},

	POST_REFRESH_TOKEN({ commit, dispatch, state }) {
		/*
		PARAMS
			* Authorization
			
		RESPONSE
			{
				accessToken: 'String',
				accessTokenExpiration: 'Time (String)',
				refreshToken: 'String'
			}
		*/
		return new Promise(resolve => {
			let refreshToken = encodeURIComponent(state.token.refreshToken)
			fetch(url + `/api/user/refreshtoken`, {
				method: 'POST',
				body: JSON.stringify(state.token),
				headers: new Headers({
					'Content-Type': 'application/json',
					refreshToken: refreshToken,
					accessToken: state.token.accessToken
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						commit('SET_TOKEN', data)
						resolve(true)
					}
				})
				.catch(error => {
					window.console.warn(error)
					resolve(false)
				})
		})
	},

	REFRESH_TOKEN_BEFORE_REQUEST({ dispatch }) {
		return new Promise(resolve => {
			if (tokenHasExpired()) {
				dispatch('POST_REFRESH_TOKEN')
					.then(success => {
						if (success) {
							resolve(true)
						} else {
							resolve(false)
						}
					})
					.catch(error => {
						window.console.error(error)
						resolve(false)
					})
			} else {
				resolve(true)
			}
		})
	},

	AUTHENTICATION_FAIL({ commit, state, dispatch }) {
		// Use if Authentication fails... Show login modal
		if (state.user) {
			commit('SET_USER', null)
			commit('TOGGLE_GLOBAL_MODAL', { showTokenExpired: true })
		}

		// If change book in cart
		if (state.cart.resvid) {
			dispatch('EMPTY_CART')
		}

		window.console.error('Authentication error - User is now logged out')
	},

	// ******************************************
	//	PROFILE
	// ******************************************
	POST_USER({ commit }, payload) {
		/*
		PARAMS
			* User data
		RESPONSE
			{
				OK or NOT?
			}
		*/
		return new Promise(resolve => {
			let encodePlusSign = encodeURIComponent(payload.mobilephoneprefix)
			//Makes a clone so we can modify the payload without destroying the original data
			const payloadClone = payload
			//we must encode payloads that can contain special characters "ÅÄÖ"
			const endcodedPayload = Object.assign({}, payloadClone, {
				name: encodeURI(payload.name),
				lastname: encodeURI(payload.lastname),
				address: encodeURI(payload.address),
				city: encodeURI(payload.city),
				country: encodeURI(payload.country),
				password: encodeURI(payload.password),
				tokenObject: null
			})

			fetch(url + `/api/customer/createcustomer`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					'X-Create-User': JSON.stringify(endcodedPayload)
				}),
				body: JSON.stringify(payload)
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 409) {
						// Conflict, user existing
						commit('SET_API_RESP_STATUS', 'User exists')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(true)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Todo - Se över detta request
	POST_RESET_PASSWORD({ commit, dispatch }, payload) {
		/*
		PARAMS
			* email string
		RESPONSE
			{
				OK or NOT?
			}
		*/
		return new Promise(resolve => {
			fetch(
				url + `/api/customer/${i18n.locale}/resetpassword?email=${payload}`,
				{
					method: 'POST',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						resolve(true)
						//return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(true)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Kollar gamla lösenordet, retunerar false om det inte stämmer
	POST_UPDATE_PASSWORD({ commit, state, dispatch }, payload) {
		/*
			PARAMS
				* id: Int
				* oldpassword: String
				* password: String
			RESPONSE
				{
					true/false
				}
			*/
		return new Promise(resolve => {
			//we must encode payloads that can contain special characters "ÅÄÖ"
			const endcodedPayload = Object.assign({}, payload, {
				id: encodeURI(payload.id),
				oldpassword: encodeURI(payload.oldpassword),
				password: encodeURI(payload.password)
			})

			fetch(url + `/api/customer/updatepassword`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken,
					'X-Update-User': JSON.stringify(endcodedPayload)
				}),
				body: payload
			})
				.then(resp => {
					if (resp.status == 200) {
						resolve(true)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Todo - Do we need this request?
	PUT_USER({ commit, state, dispatch }, payload) {
		/*
		PARAMS
		* Authorization
		* email
		* ID
		RESPONSE
			{
				User
			}
		*/

		let encodePlusSign = encodeURIComponent(payload.mobilephoneprefix)
		const payloadClone = payload
		const endcodedPayload = Object.assign({}, payloadClone, {
			name: encodeURI(payload.name),
			lastname: encodeURI(payload.lastname),
			city: encodeURI(payload.city),
			address: encodeURI(payload.address),
			mobilephoneprefix: encodePlusSign,
			tokenObject: null
		})

		return new Promise(resolve => {
			fetch(url + `/api/customer/updatecustomer`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken,
					'X-Update-User': JSON.stringify(endcodedPayload)
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 409) {
						// conflict, email exist
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data.id) {
						// Update user success
						commit('SET_USER', data)
						resolve(true)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	PUT_NEW_PASSWORD({ commit, state, dispatch }, payload) {
		/*
		PARAMS
		* Authorization
		* email
		* ID
		RESPONSE
			{
				User
			}
		*/
		return new Promise(resolve => {
			fetch(url + `/api/customer/updatecustomer`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken,
					'X-Update-User': JSON.stringify({
						id: payload.id,
						password: encodeURI(payload.password)
					})
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data.id) {
						// Update user success
						commit('SET_USER', data)
						resolve(true)
					} else {
						// Update user Fail
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	PUT_GUEST({ dispatch, commit, state }, payload) {
		/*
		PARAMS
			* Authorization
			* guest {}
		RESPONSE
			{
				Guest
			}
		*/
		return new Promise(resolve => {
			const payloadClone = payload
			const endcodedPayload = Object.assign({}, payloadClone, {
				guestlid: payload.guestlid, //Skicka 0 eller inte alls för att skapa gäst. Id för att uppdatera
				addrclid: payload.addrclid, //För att koppla till kund. (headlid)
				name: encodeURI(payload.name),
				lastname: encodeURI(payload.lastname),
				phoneprefix: encodeURI(payload.phoneprefix),
				phone3: encodeURI(payload.phone3),
				birthdate: encodeURI(payload.birthdate),
				keynumber: encodeURI(payload.keynumber),
				image: ''
			})

			fetch(url + `/api/customer/createorupdateguest`, {
				method: 'POST',
				timeout: 0,
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken,
					'X-Create-User': JSON.stringify(endcodedPayload)
				}),
				body: payload.image.includes(
					'https://r360generalstorage.blob.core.windows.net'
				)
					? ''
					: JSON.stringify(payload.image)
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					/*if (data) {
						commit('SET_GUEST', data)
					}*/
					commit('SET_GUEST', data)
					resolve(true)
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	DELETE_GUEST({ commit, dispatch, state }, payload) {
		/*
		PARAMS
			* Authorization
			* guest ID
		RESPONSE
			{
				guest ID
			}
		*/
		return new Promise(resolve => {
			fetch(
				url +
					`/api/customer/deleteguest?guestlid=${payload.guestlid}&addrclid=${payload.addrclid}`,
				{
					method: 'POST',
					headers: new Headers({
						'Content-Type': 'application/json',
						Authorization: 'Bearer ' + state.token.accessToken
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						commit('REMOVE_GUEST', data)
						resolve(true)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Hämtar all bokninger med enkel info från en användare
	GET_BOOKINGS({ commit, state, dispatch }, payload) {
		/*
		PARAMS
			* Authorization
		RESPONSE
			{
				Bookings
			}
		*/
		return new Promise(resolve => {
			fetch(url + `/api/reservation/getreservations?userId=${payload}`, {
				method: 'GET',
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken
				})
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Hämtar en full bokning från ett resvId
	GET_BOOKING({ commit, state, dispatch }, payload) {
		/*
		PARAMS
			* Authorization
			* resvId
		RESPONSE
			{
				Booking (typ cart object)
			}
		*/
		return new Promise(resolve => {
			fetch(
				url +
					`/api/reservation/${i18n.locale}/getreservation?resvId=${payload}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json',
						Authorization: 'Bearer ' + state.token.accessToken
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	GET_PDF_INVOICE({ commit, state, dispatch }, payload) {
		/*
		PARAMS
			* Authorization
		RESPONSE
			{
				PDF länk?
			}
		*/
		return new Promise(resolve => {
			fetch(
				url +
					`/api/reservation/generatepdf?headlid=${payload.headlid}&payerlid=${payload.payerlid}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json',
						Authorization: 'Bearer ' + state.token.accessToken
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.text()
					} else if (resp.status == 204) {
						// No PDF exist... booking must be payed
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	Validation
	// ******************************************
	GET_KEY_CARD_VALIDATION({ commit, dispatch }, payload) {
		/*

		Key Card Validation

		PARAMS
			keynumber = "01-1614 7133 5346 1418 3973-7" or "01-1614 7133 5346 1418 3973-7,01-1614 7133 5346 1418 3973-7"
			(multiple keynumbers seperate with ",") 

		RESPONSE
			[
				{
					keynumber: "01-1614 7133 5346 1341 5356-7 123", 
					valid: false / true
				}
			]
		*/
		return new Promise(resolve => {
			if (payload) {
				fetch(url + `/api/skipass/validatekeycard?keynumber=${payload}`, {
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				})
					.then(resp => {
						if (resp.status == 200) {
							return resp.json()
						} else if (resp.status == 204) {
							resolve(false)
						} else if (resp.status == 410) {
							commit('SET_API_RESP_STATUS', 'An unknown error occured')
							resolve(false)
						} else {
							commit('SET_API_RESP_STATUS', 'An unknown error occured')
							resolve(false)
						}
					})
					.then(data => {
						if (data) {
							resolve(data)
						} else {
							resolve(false)
						}
					})
					.catch(error => {
						window.console.error(error)
						resolve(false)
					})
			} else {
				resolve(false)
			}
		})
	},

	// ******************************************
	//	PAYMENT
	// ******************************************

	GET_PAYMENT({ commit, state, dispatch }, payload) {
		/*
		Payment, Send cart to BE and get Iframe URL to payment
		
		PARAMS
			* Authorization
			* Cart object
			
		RESPONSE
			{
				...
				cart object
				paymenturl : "url"
			}
		*/
		return new Promise(resolve => {
			fetch(url + `/api/reservation/${i18n.locale}/checkout`, {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + state.token.accessToken
				}),
				body: JSON.stringify(payload)
			})
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						// Empty cart
						resolve(false)
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 406) {
						// Cart not valid for fast checkout
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						commit('TOGGLE_GLOBAL_MODAL', { showCheckoutErrorModal: true })
						resolve(false)
					} else if (resp.status == 408) {
						// No response from r360
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						commit('TOGGLE_GLOBAL_MODAL', { showCheckoutErrorModal: true })
						resolve(false)
					} else if (resp.status == 410) {
						// Booking no longer avileble
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						commit('TOGGLE_GLOBAL_MODAL', {
							showAccommodationNotAvailable: true
						})
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						commit('TOGGLE_GLOBAL_MODAL', { showCheckoutErrorModal: true })
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// GET_CART_TOTAL_PRICE({ commit, state }, payload) {
	// 	/*
	// 	Request används för hämta totalpriset för all produkter i varukorgen

	// 	PARAMS
	// 		* Cart object
	// 	RESPONSE
	// 		{
	// 			price
	// 		}
	// 	*/
	// 	return new Promise(resolve => {
	// 		fetch(url + '/api/R360/gettotalamounttopay', {
	// 			method: 'POST',
	// 			headers: new Headers({
	// 				'Content-Type': 'application/json'
	// 			}),
	// 			body: JSON.stringify({ cartitems: payload.cartitems })
	// 		})
	// 			.then(resp => {
	// 				if (resp.status == 200) {
	// 					return resp.json()
	// 				} else if (resp.status == 204) {
	// 					resolve(false)
	// 				} else if (resp.status == 401) {
	// 					dispatch('AUTHENTICATION_FAIL')
	// 					resolve(false)
	// 				} else if (resp.status == 410) {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				} else {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				}
	// 			})
	// 			.then(data => {
	// 				if (data) {
	// 					commit('SET_CART_TOTAL_PRICE', data)
	// 					resolve(true)
	// 				} else {
	// 					resolve(false)
	// 				}
	// 			})
	// 			.catch(error => {
	// 				window.console.error(error)
	// 				resolve(false)
	// 			})
	// 	})
	// },

	// ******************************************
	//	ACCOMMODATION
	// ******************************************
	// Todo - Slå samman request?
	GET_ACCOMMODATION({ commit, dispatch }, payload) {
		/*
		hämtar ett boende med hjälp av ett unitlid och ett poollid
		
		PARAMS
			* unitlid
			* poollid
			
		RESPONSE
			{
				boende...
			}
		*/
		return new Promise(resolve => {
			fetch(
				url +
					`/api/accommodation/${i18n.locale}/getaccommodationbyid?unitlid=${payload.unitlid}&poollid=${payload.poollid}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return false
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Todo - gör till ett request?
	GET_ACCOMMODATIONS_WITH_DATES({ commit, dispatch }, payload) {
		/*
		Den här actonen hämtar boende från r360 med från och till datum
		
		PARAMS
			* unitlid
			* poollid
			
		RESPONSE
			{
				boende...
			}
		*/
		return new Promise((resolve, reject) => {
			const fromdate = payload.startDate.replace(/\//g, '-')
			const todate = payload.endDate.replace(/\//g, '-')
			const unitlid = payload.unitlid ? payload.unitlid : 0
			const poollid = payload.poollid ? payload.poollid : 0
			const campaignCode = payload.campaignCode ? payload.campaignCode : ''
			const children = payload.amountChildren ? payload.amountChildren : '0'
			const youths = payload.amountYouths ? payload.amountYouths : '0'
			const adults = payload.amountAdults ? payload.amountAdults : '0'
			const checkPrice = payload.checkPrice ? true : false
			//Testa kampanj 18feb till 21 feb 2021
			//let testkampanj = "TESTKAMPANJ"
			//url + `/api/R360/SV/accomodations?fromdate=${fromdate}&todate=${todate}&promotioncode=${testkampanj}`
			fetch(
				url +
					`/api/accommodation/${i18n.locale}/accommodations?fromdate=${fromdate}&todate=${todate}&unitlid=${unitlid}&poollid=${poollid}&promotioncode=${campaignCode}&noofchild2=${children}&noofchild3=${youths}&noofchild5=${adults}&checkPrice=${checkPrice}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return []
					} else if (resp.status == 400) {
						// return error object errorCode: 0 == invalid promotion code
						// return error object errorCode: 1 == valid promotion code but not with chosen accommodation
						// return error object errorCode: 2 == valid promotion code and accommodation but not during chosen period
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// Todo - behövs detta eller kommer det med boende med datum?
	// GET_ACCOMMODATION_ADDON({ commit }, payload) {
	// 	/*
	// 	Hämtar tillägg på valt boende

	// 	PARAMS
	// 		* unitlid
	// 		* poollid
	// 		* arrdate
	// 		* depdate

	// 	RESPONSE
	// 		{
	// 			boende?
	// 		}
	// 	*/
	// 	return new Promise(resolve => {
	// 		const arrdate = payload.startDate.replace(/\//g, '-')
	// 		const depdate = payload.endDate.replace(/\//g, '-')
	// 		const children = payload.noofchild2
	// 		const youths = payload.noofchild3
	// 		const adults = payload.noofchild5
	// 		//Test av tillägg med unit/poolid 1027&1015
	// 		fetch(
	// 			url +
	// 				`/api/accommodation/${i18n.locale}/getadditionalunitdata?unitlid=${payload.unitlid}&poollid=${payload.poollid}&arrdate=${arrdate}&depdate=${depdate}&noofchild2=${children}&noofchild3=${youths}&noofchild5=${adults}`,
	// 			{
	// 				method: 'GET',
	// 				headers: new Headers({
	// 					'Content-Type': 'application/json'
	// 				})
	// 			}
	// 		)
	// 			.then(resp => {
	// 				if (resp.status == 200) {
	// 					return resp.json()
	// 				} else if (resp.status == 204) {
	// 					return resp.json()
	// 				} else if (resp.status == 401) {
	// 					dispatch('AUTHENTICATION_FAIL')
	// 					resolve(false)
	// 				} else if (resp.status == 410) {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				} else {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				}
	// 			})
	// 			.then(data => {
	// 				if (data) {
	// 					resolve(data)
	// 				} else {
	// 					resolve(false)
	// 				}
	// 			})
	// 			.catch(error => {
	// 				window.console.error(error)
	// 				resolve(false)
	// 			})
	// 	})
	// },

	// Todo - Slå ihop
	GET_ACCOMMODATIONS_FROM_HOUSE_NUMBER({ commit, dispatch }, payload) {
		/*
		hämtar boende från ett specifikt husnummer
		
		PARAMS
			* houseNumber
			
		RESPONSE
			{
				boende
			}
		*/
		return new Promise(resolve => {
			fetch(
				url +
					`/api/accommodation/${i18n.locale}/getaccommodationbyhousenumber?housenumber=${payload.houseNumber}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return []
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	//hämtar liknande boenden för ett valt boende
	GET_SIMILARACCOMMODATION({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* ?
			
		RESPONSE
			{
				id lista
			}
		*/
		return new Promise(resolve => {
			fetch(url + '/similar/' + payload)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	GET_FILTERS({ commit, dispatch }, payload) {
		/*
		RESPONSE
			{
				**: [{}...]
				**: [{}...]
			}
		*/
		return new Promise(resolve => {
			fetch(url + `/api/accommodation/${i18n.locale}/getfilters`)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						// strip any html for the text resources...
						if (data.textResources) {
							for (let i = 0; i < data.textResources.length; i++) {
								const resource = data.textResources[i]
								resource.body = stripHtml(resource.body)
							}
						}

						commit('SET_FILTERS', data)
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	GET_ACCOMMODATION_PRICEOVERVIEW({ commit, dispatch }, payload) {
		//https://klappen-api-test.azurewebsites.net/api/accommodation/priceoverview?unitlid=1512&poollid=1088&noofchild2=${children}&noofchild3=${youths}&noofchild5=${adults}

		/*
		hämtar ett boendes prisöversikt med hjälp av ett unitlid och ett poollid
		
		PARAMS
			* unitlid
			* poollid
			* noofchild2
			* noofchild3
			* noofchild5
			
		RESPONSE
			{
				priceoverview...
			}
		*/

		return new Promise(resolve => {
			//return new Promise((resolve, reject) => {
			const unitlid = payload.unitlid ? payload.unitlid : 0
			const poollid = payload.poollid ? payload.poollid : 0
			const children = payload.children ? payload.children : '0'
			const youths = payload.youths ? payload.youths : '0'
			const adults = payload.adults ? payload.adults : '0'

			fetch(
				url +
					`/api/accommodation/${i18n.locale}/priceoverview?unitlid=${unitlid}&poollid=${poollid}&noofchild2=${children}&noofchild3=${youths}&noofchild5=${adults}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return false
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	SKIPASS
	// ******************************************
	// GET_SKIPASS({ commit, dispatch }, payload) {
	// 	/*
	// 	PARAMS
	// 		* fromdate

	// 	RESPONSE
	// 		...
	// 	*/
	// 	const fullUrl =
	// 		url + `/api/skipass/${i18n.locale}/getskipass?fromdate=${payload}`
	// 	return new Promise(resolve => {
	// 		fetch(isLocal ? '/skipassData.json' : fullUrl)
	// 			.then(resp => {
	// 				if (resp.status == 200) {
	// 					return resp.json()
	// 				} else if (resp.status == 204) {
	// 					return resp.json()
	// 				} else if (resp.status == 410) {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				} else {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				}
	// 			})
	// 			.then(data => {
	// 				if (data) {
	// 					resolve(data)
	// 				} else {
	// 					resolve(false)
	// 				}
	// 			})
	// 			.catch(error => {
	// 				window.console.error(error)
	// 				resolve(false)
	// 			})
	// 	})
	// },

	// Hämtar tillgängliga datum för skipass
	// GET_AVAILABLE_SKIPASS({ commit, dispatch }, payload) {
	// 	/*
	// 	RESPONSE
	// 		[
	// 			dates
	// 		]
	// 	*/
	// 	return new Promise(resolve => {
	// 		fetch(url + `/api/skipass/getdates`)
	// 			.then(resp => {
	// 				if (resp.status == 200) {
	// 					return resp.json()
	// 				} else if (resp.status == 204) {
	// 					return resp.json()
	// 				} else if (resp.status == 410) {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				} else {
	// 					commit('SET_API_RESP_STATUS', 'An unknown error occured')
	// 					resolve(false)
	// 				}
	// 			})
	// 			.then(data => {
	// 				if (data) {
	// 					resolve(data)
	// 				} else {
	// 					resolve(false)
	// 				}
	// 			})
	// 			.catch(error => {
	// 				window.console.error(error)
	// 				resolve(false)
	// 			})
	// 	})
	// },

	GET_SKIPASS({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* fromdate
			* campaignCode
			
		RESPONSE
			...
		*/
		const fromdate = payload.startDate.replace(/\//g, '-')
		const campaignCode = payload.campaignCode ? payload.campaignCode : ''
		const fullUrl =
			url +
			`/api/skipass/${i18n.locale}/getskipass?fromdate=${fromdate}&promotioncode=${campaignCode}`

		return new Promise(resolve => {
			fetch(isLocal ? '/skipassData.json' : fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						data.items.forEach(
							item =>
								(item.ages = item.ages.filter(each => {
									if (
										each.promotion !== undefined &&
										each.promotion !== null &&
										each.promotion.promotioncode == null
									) {
										each.promotion = undefined // for some reson this is a object with null values when no promotion code is set. quick but not butiful ToDo: fix in bakend.
									}

									each.isDiscount =
										each.ordinaryPrice !== -1 &&
										each.ordinaryPrice !== 0 &&
										each.ordinaryPrice !== '' &&
										each.price !== -1 &&
										each.price !== 0 &&
										each.price !== '' &&
										each.ordinaryPrice !== each.price

									return each
								}))
						)

						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	GET_AVAILABLE_SKIPASS({ commit, dispatch }, payload) {
		/*
		Den här actonen hämtar tillgängliga datum för skipass
		
		PARAMS
			* campaignCode
					
		RESPONSE
			[
				dates
			]
		*/
		const campaignCode = payload
			? payload.campaignCode
				? payload.campaignCode
				: ''
			: ''

		return new Promise((resolve, reject) => {
			fetch(
				url +
					`/api/skipass/${i18n.locale}/getdates?promotioncode=${campaignCode}`,
				{
					method: 'GET',
					headers: new Headers({
						'Content-Type': 'application/json'
					})
				}
			)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return []
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						// strip any html for the text resources...
						if (data.textResources) {
							for (let i = 0; i < data.textResources.length; i++) {
								const resource = data.textResources[i]
								resource.body = stripHtml(resource.body)
							}
						}
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	SKISCHOOL
	// ******************************************
	//Hämtar skiskola från valt datum
	GET_SKISCHOOL({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* fromdate
			* toDate
			
		RESPONSE
			[
				{Skischool}
			]
		*/
		const fullUrl =
			url +
			`/api/activity/${i18n.locale}/getactivities?fromDate=${payload.fromdate}&toDate=${payload.todate}&type=1003`
		return new Promise(resolve => {
			fetch(isLocal ? '/skischoolData.json' : fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	//Hämtar tillgängliga datum för skidskola
	GET_AVAILABLE_SKISCHOOL({ commit, dispatch }, payload) {
		/*		
		RESPONSE
			[
				dates
			]
		*/
		return new Promise(resolve => {
			fetch(url + `/api/activity/${i18n.locale}/getdates?type=1003`)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						// strip any html for the text resources...
						if (data.textResources) {
							for (let i = 0; i < data.textResources.length; i++) {
								const resource = data.textResources[i]
								resource.body = stripHtml(resource.body)
							}
						}
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	ACTIVITIES
	// ******************************************
	//Hämtar aktiviteter från valt datum
	GET_ACTIVITIES({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* fromdate
			* toDate
			
		RESPONSE
			[
				{Activities}
			]
		*/
		const fullUrl =
			url +
			`/api/Activity/${i18n.locale}/getactivities?fromDate=${payload.fromdate}&toDate=${payload.todate}&type=1004`
		//https://api-stage.klappen.se/api/Activity/sv/getactivities?fromDate=2022-02-02&toDate=2022-02-09&type=1004
		return new Promise(resolve => {
			fetch(isLocal ? '/skischoolData.json' : fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	//Hämtar tillgängliga datum för aktiviteter
	GET_AVAILABLE_ACTIVITIES({ commit, dispatch }, payload) {
		/*		
		RESPONSE
			[
				dates
			]
		*/
		return new Promise(resolve => {
			fetch(url + `/api/Activity/${i18n.locale}/getdates?type=1004`)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						// strip any html for the text resources...
						if (data.textResources) {
							for (let i = 0; i < data.textResources.length; i++) {
								const resource = data.textResources[i]
								resource.body = stripHtml(resource.body)
							}
						}
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	SKIRENTALS
	// ******************************************
	//Hämtar skidutrustning från valt datum
	GET_SKIRENTALS({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* fromdate
			* toDate
			
		RESPONSE
			[
				{Skirental}
			]
		*/
		const fullUrl =
			url +
			`/api/skiletting/${i18n.locale}/getskilettingproducts?fromdate=${payload.fromdate}&todate=${payload.todate}`
		return new Promise(resolve => {
			fetch(isLocal ? '/skirentalData.json' : fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	//Hämtar tillgängliga datum för skidutrustning
	GET_AVAILABLE_SKIRENTALS({ commit, dispatch }, payload) {
		/*		
		RESPONSE
			[
				dates
			]
		*/
		return new Promise(resolve => {
			fetch(url + `/api/skiletting/${i18n.locale}/getdates`)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 401) {
						dispatch('AUTHENTICATION_FAIL')
						resolve(false)
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						// strip any html for the text resources...
						if (data.textResources) {
							for (let i = 0; i < data.textResources.length; i++) {
								const resource = data.textResources[i]
								resource.body = stripHtml(resource.body)
							}
						}
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	// ******************************************
	//	Upsell
	// ******************************************
	// Hämtar tillvalsprodukter från valt datum med upsell parametern "true"
	GET_UPSELL({ commit, dispatch }, payload) {
		/*		
		PARAMS
			* fromdate
			* toDate
			* upsell
		RESPONSE
			[
				{Upsell}
			]
		*/
		const fullUrl =
			url +
			`/api/skiletting/${i18n.locale}/getskilettingproducts?fromdate=${payload.fromdate}&todate=${payload.todate}&upsell=true`
		return new Promise(resolve => {
			fetch(isLocal ? '/skirentalData.json' : fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	//Hämtar land vid registering av ny användare
	GET_COUNTRIES({ commit, dispatch }) {
		/*		
		RESPONSE
			språk?
		*/
		return new Promise(resolve => {
			fetch(url + `/api/customer/${i18n.locale}/getcountries`)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	},

	POST_ERROR_LOG({}, payload) {
		/*		
		PARAMS
			* fromdate
			* toDate
			* upsell
		RESPONSE
			[
				{Upsell}
			]
		*/
		const fullUrl =
			url +
			`/api/skiletting/${i18n.locale}/getskilettingproducts?fromdate=${payload.fromdate}&todate=${payload.todate}&upsell=true`
		return new Promise(resolve => {
			fetch(fullUrl)
				.then(resp => {
					if (resp.status == 200) {
						return resp.json()
					} else if (resp.status == 204) {
						return resp.json()
					} else if (resp.status == 410) {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					} else {
						commit('SET_API_RESP_STATUS', 'An unknown error occured')
						resolve(false)
					}
				})
				.then(data => {
					if (data) {
						resolve(data)
					} else {
						resolve(false)
					}
				})
				.catch(error => {
					window.console.error(error)
					resolve(false)
				})
		})
	}
}
